export default "__VITE_ASSET__weRCb$_y__"